// extracted by mini-css-extract-plugin
module.exports = {"fetchingContainer":"FetchingLoader_fetchingContainer__1R58c","spinner":"FetchingLoader_spinner__3DpeZ"};